export enum LocalStorageKeys {
  OtherContactOverviewFilter = 'otherContactOverviewFilter',
  MemberOverviewFilter = 'memberOverviewFilter',
  MemberAdvancedSearchFilter = 'memberAdvancedSearchFilter',
  InvoiceSearchFilter = 'invoiceSearchFilter',
  InvoiceMissionDetailFilter = 'invoiceMissionDetailFilter',
  GroupMessageEmailSearchFilter = 'groupMessageEmailSearchFilter',
  GroupMessageSmsSearchFilter = 'GroupMessageSmsSearchFilter',
  AdminInvoiceTemplateSearchFilter = 'adminInvoiceTemplateSearchFilter',
  PaymentAccountingSearchFilter = 'paymentAccountingSearchFilter',
  PaymentTransactionSearchFilter = 'paymentTransactionSearchFilter',
  IncomingBankPaymentSearchFilter = 'incomingBankPaymentSearchFilter',
  GiftSearchFilter = 'giftSearchFilter',
  ExportFileSearchFilter = 'exportFileSearchFilter',
  FundraiserSettingsSearchFilter = 'fundraiserSettingsSearchFilter',
  WebFormsSearchFilter = 'webFormsSearchFilter',
  EventSearchFilter = 'eventSearchFilter',
  EventDateFilterList = 'eventDateFilterList',
  EventDateFilterCalendar = 'eventDateFilterCalendar',
  EventDateMemberMeFilterCalendar = 'eventDateMemberMeFilterCalendar',
  InvoiceAddressSearchFilter = 'invoiceAddressSearchFilter',
  AutogiroConsentSearchFilter = 'autogiroConsentSearchFilter',
  MemberAutogiroStatusFilter = 'memberAutogiroStatusFilter',
  AutogiroCreateFileSearchFilter = 'autogiroCreateFileSearchFilter',
  StatisticsMemberGrowthSearchFilter = 'statisticsMemberGrowthSearchFilter',
  StatisticsPaymentDistributionSearchFilter = 'statisticsPaymentDistributionSearchFilter',
  FundraisingDistributionSearchFilter = 'fundraisingDistributionSearchFilter',
  ArticleRegisterFilter = 'articleRegisterFilter',
  ArticleCategoryFilter = 'articleCategoryFilter',
  MemberStripeStatusFilter = 'memberStripeStatusFilter',
  MemberStripeCustomerFilter = 'memberStripeCustomerFilter',
  MemberSwishStatusFilter = 'memberSwishStatusFilter',
  SwishConsentFilter = 'swishConsentFilter',
  PaymentsFilter = 'paymentsFilter',
  MemberProfileGroupSearchFilter = 'memberProfileGroupSearchFilter',
  SnapshotExportInProgress = 'snapshotExportInProgress',
  SmsBillingReportExportInProgress = 'smsBillingReportExportInProgress',
  EInvoiceReceiverFilter = 'eInvoiceReceiverFilter',
  EInvoiceAddressFilter = 'eInvoiceAddressFilter',
  EInvoiceApplicationsFilter = 'eInvoiceApplicationsFilter',
  EInvoiceLinkedOthersFilter = 'eInvoiceLinkedOthersFilter',
  InvoiceDashboardPeriods = 'invoiceDashboardPeriods',
  DonorSearchFilter = 'donorSearchFilter',
}
